
/**
 * Module dependencies.
 */

import { fetchCollection } from 'src/api/app/collections/fetch-collection';
import {
  fetchProductsCollection,
  paginationLimit
} from 'src/api/app/products/fetch-products-collection';
import { routes } from 'src/core/routes';

import CollectionDetailsPage, {
  Props
} from 'src/components/pages/collections/collection-details';

import React, { ReactElement } from 'react';

/**
 * `CollectionDetails` page.
 */

const CollectionDetails = (props: Props): ReactElement => (
  <CollectionDetailsPage {...props} />
);

/**
 * Export `getServerSideProps`.
 */

export async function getServerSideProps({ locale, params, query }) {
  const data = await fetchCollection({
    hasPreview: query?.preview,
    locale,
    slug: params?.slug
  });

  if (!data) {
    return {
      redirect: {
        destination: `/${locale}${routes[locale].collections}`,
        permanent: true
      }
    };
  }

  const products = await fetchProductsCollection({
    collectionId: data?.id,
    locale,
    params: {
      limit: paginationLimit,
      page: 1
    }
  });

  return {
    props: {
      data,
      products: {
        pageParams: [1],
        pages: [products ?? []]
      }
    }
  };
}

/**
 * Export `CollectionDetails` page.
 */

export default CollectionDetails;
